module.exports = __webpack_public_path__ + "img/680.de097583.jpg";